import { render, staticRenderFns } from "./Graphic.vue?vue&type=template&id=036dd1ae&scoped=true"
import script from "./Graphic.vue?vue&type=script&lang=js"
export * from "./Graphic.vue?vue&type=script&lang=js"
import style0 from "./Graphic.vue?vue&type=style&index=0&id=036dd1ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036dd1ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VIcon,VList,VMenu})
